import { createContext, useContext, useState, useEffect, useCallback } from "react";

const RefreshContext = createContext(null);
export const useRefresh = () => useContext(RefreshContext);

export function RefreshProvider({ children }) {
  const [tick, setTick] = useState(0);
  const [lastRefreshed, setLastRefreshed] = useState(Date.now());
  const [auto, setAuto] = useState(true);

  const bump = useCallback(() => {
    setTick((t) => t + 1);
    setLastRefreshed(Date.now());
  }, []);

  useEffect(() => {
    if (!auto) return;
    const id = setInterval(bump, 30000);
    return () => clearInterval(id);
  }, [auto, bump]);

  return (
    <RefreshContext.Provider value={{ tick, bump, lastRefreshed, auto, setAuto }}>
      {children}
    </RefreshContext.Provider>
  );
}
